import * as Types from '../../../__generated__/schema';

import { AlertSummaryFull } from '../fragments/AlertSummaryFull.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAlertsAssigneeByIdVariables = Types.Exact<{
  input: Types.UpdateAlertsAssigneeByIdInput;
}>;

export type UpdateAlertsAssigneeById = {
  updateAlertsAssigneeById: { alerts: Array<AlertSummaryFull> };
};

export const UpdateAlertsAssigneeByIdDocument = gql`
  mutation UpdateAlertsAssigneeById($input: UpdateAlertsAssigneeByIdInput!) {
    updateAlertsAssigneeById(input: $input) {
      alerts {
        ...AlertSummaryFull
      }
    }
  }
  ${AlertSummaryFull}
`;
export type UpdateAlertsAssigneeByIdMutationFn = Apollo.MutationFunction<
  UpdateAlertsAssigneeById,
  UpdateAlertsAssigneeByIdVariables
>;

/**
 * __useUpdateAlertsAssigneeById__
 *
 * To run a mutation, you first call `useUpdateAlertsAssigneeById` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertsAssigneeById` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertsAssigneeById, { data, loading, error }] = useUpdateAlertsAssigneeById({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertsAssigneeById(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAlertsAssigneeById,
    UpdateAlertsAssigneeByIdVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAlertsAssigneeById, UpdateAlertsAssigneeByIdVariables>(
    UpdateAlertsAssigneeByIdDocument,
    options,
  );
}
export type UpdateAlertsAssigneeByIdHookResult = ReturnType<typeof useUpdateAlertsAssigneeById>;
export type UpdateAlertsAssigneeByIdMutationResult =
  Apollo.MutationResult<UpdateAlertsAssigneeById>;
export type UpdateAlertsAssigneeByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateAlertsAssigneeById,
  UpdateAlertsAssigneeByIdVariables
>;
export function mockUpdateAlertsAssigneeById({
  data,
  variables,
  errors,
}: {
  data: UpdateAlertsAssigneeById;
  variables?: UpdateAlertsAssigneeByIdVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateAlertsAssigneeByIdDocument, variables },
    result: { data, errors },
  };
}
